export const TrainTypeEnum = {
  AEx: 'ARRIVA EXPRESS',
  EC: 'EuroCity',
  EN: 'EuroNight',
  Ex: 'Expres',
  IC: 'InterCity',
  LE: 'LEO Express',
  LET: 'LET',
  NJ: 'nightjet',
  Os: 'Osobní vlak',
  R: 'Rychlík',
  RJ: 'RegioJet',
  Rj: 'railjet',
  Rx: 'Rex',
  SC: 'SuperCity',
  Sp: 'Spěšný vlak',
  TL: 'Trilex',
  TLX: 'Trilex - expres',
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/Map/TrainTypeEnum.js